import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  quote: 'Compré un domingo a la noche. El lunes entré al estudio con el plan exacto de la clase. Las clases del Tomo 1 son exactamente lo que necesitaba para mis grupos de principiantes. Nunca más improviso.',
  name: 'Sofía M.',
  location: 'Buenos Aires',
  role: 'Profe de Yoga en Estudio Propio'
}, {
  quote: 'El Tomo 5, el de poblaciones especiales, me cambió todo. El primer mes, alumnas que llevaban meses estancadas mejoraron visiblemente su movilidad y su calidad de movimiento. El protocolo de seguridad me da la tranquilidad que antes no tenía.',
  name: 'Carolina R.',
  location: 'Rosario',
  role: 'Profe de Yoga en Centro de Bienestar'
}, {
  quote: 'El sistema de Vinyasa del Tomo 4 es único en el mercado. 12 clases listas para usar, con las transiciones descriptas paso a paso. Antes tardaba horas armando una secuencia. Ahora abro el PDF y en 5 minutos tengo todo listo.',
  name: 'Valentina F.',
  location: 'Córdoba',
  role: 'Profe de Yoga Grupal e Individual'
}, {
  quote: 'La Guía de Cues Verbales eliminó el problema del silencio incómodo en clase. Ahora tengo siempre algo preciso para decir. Mis alumnas me dicen que se sienten mucho más guiadas y seguras.',
  name: 'Luciana P.',
  location: 'Tucumán',
  role: 'Profe Particular y en Gimnasio'
}, {
  quote: 'La tasa de abandono de mis grupos bajó muchísimo. Sin cambiar lo que enseño. Solo aplicando el sistema de progresión mensual del calendario y la variedad de los 6 tomos. Las alumnas ahora quieren venir porque siempre hay algo nuevo.',
  name: 'Marcela G.',
  location: 'Mendoza',
  role: 'Profe de Yoga Online y Presencial'
}, {
  quote: 'El Script del Bono de Meditaciones me salvó de perder alumnas que venían a probar. Ahora sé exactamente cómo cerrar cada clase. Mi tasa de conversión de primera clase a pack mensual subió de manera notable.',
  name: 'Laura V.',
  location: 'Santa Fe',
  role: 'Profe de Yoga en Estudio Propio'
}, {
  quote: 'El Yoga Terapéutico Pro me cambió la cabeza. Nunca había dimensionado el riesgo que corría sin adaptaciones claras para mis alumnas con condiciones especiales. Ahora trabajo con una tranquilidad y un profesionalismo que antes no tenía.',
  name: 'Ana R.',
  location: 'Salta',
  role: 'Profe de Yoga en Centro de Salud Integrativa'
}];
export function ExtendedTestimonials() {
  return <section className="py-12 md:py-24 bg-gray-50" data-id="element-89">
      <div className="container mx-auto px-4" data-id="element-90">
        <div className="text-center mb-8 md:mb-16" data-id="element-91">
          <h2 className="text-2xl md:text-4xl font-serif font-bold text-gray-900 mb-2 md:mb-4" data-id="element-92">
            +500 profes de Yoga de todo el país ya tienen su{' '}
            <span className="text-yoga-purple-600" data-id="element-93">YOGA RESUELTA</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 max-w-7xl mx-auto" data-id="element-94">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index % 3 * 0.1
        }} className="bg-white rounded-xl md:rounded-2xl p-5 md:p-8 shadow-sm hover:shadow-md transition-shadow border border-gray-100 flex flex-col h-full" data-id="element-95">
              <div className="flex gap-1 mb-3 md:mb-4" data-id="element-96">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 md:w-4 md:h-4 fill-yoga-gold text-yoga-gold" data-id="element-97" />)}
              </div>
              <p className="text-gray-700 italic mb-4 md:mb-6 flex-grow text-xs md:text-sm leading-relaxed" data-id="element-98">
                "{testimonial.quote}"
              </p>
              <div className="mt-auto pt-3 md:pt-4 border-t border-gray-50" data-id="element-99">
                <p className="font-bold text-yoga-purple-900 text-xs md:text-sm" data-id="element-100">
                  {testimonial.name}
                </p>
                <p className="text-[10px] md:text-xs text-yoga-purple-600 font-medium" data-id="element-101">
                  {testimonial.location}
                </p>
                <p className="text-[10px] md:text-xs text-gray-500 mt-0.5" data-id="element-102">
                  {testimonial.role}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}